module.exports = __webpack_public_path__ + "img/chat_grey.0741cc3f.svg";